import React from 'react';

import { ModalContainer, Overlay } from './ModalStyles';

const Modal = (props) => {
  return (
    <ModalContainer>
      <Overlay />
      {props.children}
    </ModalContainer>
  );
};

export default Modal;
